import {AbstractType, getTemplate} from "./AbstractType";

export let template = getTemplate();

export class viewModel extends AbstractType {
    protected override readonly showSubmitButton: boolean = false;
}
